<template>
  <div id="userPicker">
    <model v-if="newShowModel" :buttonType="0" :title="title" :minWidth="'1100px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div class="allSearch">
        <div class="newSearch m_b_10 p_t5 d_flex" v-if="pickerModel === 'wechatUser'">
          <div  style="white-space: nowrap;width: 100%">
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="姓名" v-model="userPostData.NickName">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="城市" v-model="userPostData.City">
            </p>
          </div>
          <div>
            <button @click="searchUser" class="redButton">
              <i class="icon iconfont iconsousuo"></i>
              搜索
            </button>
          </div>
        </div>
        <div class="newSearch m_b_10 p_t5 d_flex" style="align-items: flex-end" v-else-if="pickerModel === 'groups'">
          <div style="white-space: normal;">
            <p v-if="needGroup">
              <abbr class="d_i">
                <allSelect :chooseData="groupList" :needReturn="'id'" :placeholder="'请选择分组'" :matchValue="'name'" :showValue="'{{name}}'" v-model="userPostData.groupId">
                </allSelect>
              </abbr>
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="姓名/微信号" v-model="userPostData.UserName">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="所在地" v-model="userPostData.city">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="科室" v-model="userPostData.Dept">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="医院" v-model="userPostData.Inst">
            </p>
            <p>
              <abbr class="d_i">
                <allSelect :chooseData="fildsList" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="userPostData.FieldId">
                </allSelect>
              </abbr>
            </p>
            <p>
              <abbr class="d_i">
                <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="userPostData.IndicationId">
                </allSelect>
              </abbr>
            </p>
          </div>
          <div>
            <button style="margin-bottom: 10px" @click="searchUser" class="redButton">
              <i class="icon iconfont iconsousuo"></i>
              搜索
            </button>
          </div>
        </div>
        <div class="newSearch m_b_10 p_t5 d_flex" style="align-items: flex-end" v-else-if="pickerModel === 'employeeDepartment'">
          <div style="white-space: normal;">
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="姓名" v-model="groupEmployeePostData.Name">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="邮箱" v-model="groupEmployeePostData.Email">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="部门" v-model="groupEmployeePostData.Department">
            </p>
          </div>
          <div>
            <button style="margin-bottom: 10px" @click="getAllUser(1)" class="redButton">
              <i class="icon iconfont iconsousuo"></i>
              搜索
            </button>
          </div>
        </div>



        <div class="newSearch m_b_10 p_t5 d_flex" style="align-items: flex-end" v-else>
          <div style="white-space: normal;">
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="姓名" v-model="userPostData.ChineseName">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="工作邮箱" v-model="userPostData.Email">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="部门" v-model="userPostData.Department">
            </p>
            <p>
              <input @keyup.enter="searchUser" class="allInput" type="text" placeholder="职位" v-model="userPostData.JobTitle">
            </p>
          </div>
          <div>
            <button @click="searchUser" class="redButton">
              <i class="icon iconfont iconsousuo"></i>
              搜索
            </button>
          </div>
        </div>
        <div style="display: inline-block;vertical-align: top;width:70%;max-height: 340px;overflow: auto;" class="userWidth65">
          <table v-if="pickerModel === 'wechatUser'" cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr style="background-color: #FBFBFB;color: #797979">
              <th width="5%">
                <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                <label for="ALLchecked"></label>
              </th>
              <th>姓名</th>
              <th>城市</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in userList" :key="index">
              <td width="5%">
                <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                <label :for="'userChecked' + index"></label>
              </td>
              <td width="10%" class="NoWrap" style="max-width: 100px" :title="item.nickName">{{item.nickName}}</td>
              <td class="NoWrap" width="20%" style="max-width: 100px" :title="item.city">{{item.city}}</td>
            </tr>
            </tbody>
          </table>
          <table v-else-if="pickerModel === 'groups'" cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr style="background-color: #FBFBFB;color: #797979">
              <th width="5%">
                <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                <label for="ALLchecked"></label>
              </th>
              <th>姓名/微信号</th>
              <th>所在地</th>
              <th>科室</th>
              <th>医院</th>
              <th>领域</th>
              <th>适应症</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in userList" :key="index">
              <td width="5%">
                <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                <label :for="'userChecked' + index"></label>
              </td>
              <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.name">{{item.docName ? item.docName.replace(/ /g, '&nbsp;') : ''}}</td>
              <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.city">{{item.city}}</td>
              <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.department">{{item.department}}</td>
              <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.instName">{{item.instName}}</td>
              <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.fields">{{item.fields}}</td>
              <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.indications">{{item.indications}}</td>
            </tr>
            </tbody>
          </table>

          <table v-else-if="pickerModel === 'employeeDepartment'" cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr style="background-color: #FBFBFB;color: #797979">
              <th width="5%">
                <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                <label for="ALLchecked"></label>
              </th>
              <th>姓名</th>
              <th>工作邮箱</th>
              <th>部门</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in userList" :key="index">
              <td width="5%">
                <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                <label :for="'userChecked' + index"></label>
              </td>
              <td width="10%" class="NoWrap" style="max-width: 100px" :title="item.name">{{item.name}}</td>
              <td class="NoWrap" width="20%" style="max-width: 100px" :title="item.email">{{item.email}}</td>
              <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.department">{{item.department}}</td>
            </tr>
            </tbody>
          </table>
          <table v-else cellspacing="0" class="allTable alltableHui">
            <thead>
            <tr style="background-color: #FBFBFB;color: #797979">
              <th width="5%">
                <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                <label for="ALLchecked"></label>
              </th>
              <th>姓名</th>
              <th>工作邮箱</th>
              <th>部门</th>
              <th>职位</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in userList" :key="index">
              <td width="5%">
                <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                <label :for="'userChecked' + index"></label>
              </td>
              <td width="10%" class="NoWrap" style="max-width: 100px" :title="item.name">{{item.chineseName.replace(/ /g, '&nbsp;')}}</td>
              <td class="NoWrap" width="20%" style="max-width: 100px" :title="item.email">{{item.email}}</td>
              <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.org_Acronym">{{item.department}}</td>
              <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.jobTitle">{{item.jobTitle}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="display: inline-block;vertical-align: top;width:30%" class="userWidth35">
          <div style="padding-left: 20px;color: #666" class="f_w">已选成员：</div>
          <div v-if="pickerModel === 'wechatUser'" style="height: 280px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 5px;">
            <div :title="item.nickName" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.nickName}} <b @click="removeSelect(item.id)">X</b> </div>
          </div>
          <div v-else-if="pickerModel === 'groups'" style="height: 280px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 5px;">
            <div :title="item.docName" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.docName}} <b @click="removeSelect(item.openId)">X</b> </div>
          </div>
          <div v-else-if="pickerModel === 'employeeDepartment'" style="height: 280px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 5px;">
            <div :title="item.docName" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.name}} <b @click="removeSelect(item.openId)">X</b> </div>
          </div>
          <div v-else style="height: 280px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 5px;">
            <div :title="item.chineseName + '-' + item.email" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.chineseName}}-{{item.email}} <b @click="removeSelect(item.employeeId)">X</b> </div>
          </div>
        </div>
        <div v-if="pickerModel === 'groups'">
          <newPage v-on:on-changeSize="changeNewSize" :needPageSize="true" :pageSize="userPostData.PageSize" v-if="userTotalPage !== 0 && newShowModel" :totalCount="userTotalCount" v-on:on-getList="getAllUser($event)" :totalPage="userTotalPage" :page="userPage" ></newPage>
        </div>
        <div v-else-if="pickerModel === 'wechatUser'">
          <newPage v-if="userTotalPage !== 0 && newShowModel" :totalCount="userTotalCount" v-on:on-getList="getAllUser($event)" :totalPage="userTotalPage" :page="userPage" ></newPage>
        </div>
        <div v-else-if="pickerModel === 'employeeDepartment'">
          <newPage v-if="userTotalPage !== 0 && newShowModel" :totalCount="userTotalCount" v-on:on-getList="getAllUser($event)" :totalPage="userTotalPage" :page="userPage" ></newPage>
        </div>
        <div v-else>
          <newPage v-on:on-changeSize="changeNewSize" :needPageSize="true" v-if="userTotalPage !== 0 && newShowModel" :totalCount="userTotalCount" v-on:on-getList="getAllUser($event)" :totalPage="userTotalPage" :page="userPage" ></newPage>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import newPage from './page'
export default {
  name: 'page',
  model: {
    prop: 'newShowModel',
    event: 'newShowModel'
  },
  props: [
    'title',
    'userListType',
    'newShowModel',
    'pickerModel',
    'needGroup',
    'groupId',
    'appId'
  ],
  data () {
    return {
      allgender: [
        {
          id: -1,
          name: '未知'
        },
        {
          id: 0,
          name: '男'
        },
        {
          id: 1,
          name: '女'
        },
        {
          id: 2,
          name: '性别'
        }
      ],
      selectAll: false,
      userPostData: {
        groupId: '0',
        value: '',
        Field: '',
        FieldId: '',
        IndicationId: '',
        name: '',
        Email: '',
        org_Acronym: '',
        keywords: '',
        ChineseName: '',
        Department: '',
        JobTitle: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize,
        IndicationName: '' // 适应症
      },
      usergroupData: {
        groupId: '0',
        name: '',
        Email: '',
        org_Acronym: '',
        gender: 2,
        company_Name: '',
        location: '',
        building_Long: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      userTotalPage: 0,
      userPage: 0,
      userTotalCount: 0,
      originUserList: [],
      userList: [],
      chooseUserList: [],
      chooseUserIdList: [],
      chooseIdList: [],
      groupList: [{id: '0', name: '请选择分组'}],
      fildsList: [{id: '', name: '请选择领域'}],
      indicationsList: [], // 适应症
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      groupEmployeePostData: {
        Name: '',
        Email: '',
        Department: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    console.log(this.pickerModel)
    if (this.needGroup) {
      this.getGroupList()
    }
    this.getFildsList()
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getAllUser(1)
  },
  methods: {
    changeNewSize (e) {
      this.userPostData.PageSize = e
      this.getAllUser(1)
    },
    getGroupList () {
      let url = this.$commonJs.returnQuery('/api/Group/GetByName', {PageIndex: 1, PageSize: 9999})
      this.$axiox.getList(url).then(msg => {
        this.groupList = this.groupList.concat(msg.data)
      })
    },
    getFildsList () {
      let url = this.$commonJs.returnQuery('/api/Dict/GetFields', {})
      this.$axiox.getList(url).then(msg => {
        // for (let i = 0; i < msg.data.length; i++) {
        //   msg.data[i].postId = msg.data[i].name
        // }
        this.fildsList = this.fildsList.concat(msg.data)
      })
    },
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        // console.log(res, 'getIndicationsList')
        // for (let i = 0; i < res.length; i++) {
        //   res[i].postId = res[i].name
        // }
        this.indicationsList = [
          {id: '', name: '请选择适应症'},
          ...res
        ]
        console.log(this.indicationsList, 'this.indicationsList')
      })
    },
    searchUser () {
      this.getAllUser(1)
    },
    // 选取所有人
    chooseAllData () {
      for (let i = 0; i < this.userList.length; i++) {
        this.$set(this.userList[i], 'checked', this.selectAll)
        if (this.pickerModel === 'wechatUser') {
          if (this.selectAll) {
            this.chooseUserList.push(this.userList[i])
            this.chooseUserIdList.push(this.userList[i].id)
            this.chooseIdList.push(this.userList[i].openId)
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].id) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].id), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].id), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].id), 1)
              i--
            }
          }
        } else if (this.pickerModel === 'groups') {
          if (this.selectAll) {
            this.chooseUserList.push(this.userList[i])
            this.chooseUserIdList.push(this.userList[i].openId)
            this.chooseIdList.push(this.userList[i].openId)
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        } else if (this.pickerModel === 'employeeDepartment') {
          if (this.selectAll) {
            this.chooseUserList.push(this.userList[i])
            this.chooseUserIdList.push(this.userList[i].openId)
            this.chooseIdList.push(this.userList[i].openId)
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        } else {
          if (this.selectAll) {
            this.chooseUserList.push(this.userList[i])
            this.chooseUserIdList.push(this.userList[i].employeeId)
            this.chooseIdList.push(this.userList[i].employeeId)
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].employeeId) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].employeeId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].employeeId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].employeeId), 1)
              i--
            }
          }
        }
      }
    },
    //  getEmployeeList (pageIndex) {
    //   this.groupEmployeePostData.PageIndex = pageIndex
    //   let url = this.$commonJs.returnQuery('/api/Group/GetAllGroupEmployees', this.groupUserPostData)
    //   this.$axiox.getList(url).then(msg => {
    //     this.userPage = pageIndex
    //     this.userList = msg.data || msg
    //     this.originUserList = JSON.parse(JSON.stringify(msg.data || msg))
    //     this.userTotalPage = Math.ceil(msg.total / this.userPostData.PageSize)
    //     this.userTotalCount = msg.total
    //     let num = 0
    //     for (let i = 0; i < this.userList.length; i++) {
    //       if (this.chooseUserIdList.indexOf(this.userList[i].id) >= 0) {
    //         this.$set(this.userList[i], 'checked', true)
    //       }
    //       if (this.userList[i].checked) {
    //         num++
    //       }
    //     }
    //     if (num === this.userList.length) {
    //       this.selectAll = true
    //     } else {
    //       this.selectAll = false
    //     }
    //     console.log(this.userTotalPage)
    //   })
    // },
    // 获取所有用户
    getAllUser (pageIndex) {
      console.log(this.pickerModel)
      let url
      let allAxios
      if (this.pickerModel === 'groups') {
        this.userPostData.PageIndex = pageIndex
        if (this.needGroup) {
          if (parseInt(this.userPostData.groupId)) {
            url = this.$commonJs.returnQuery('/api/Group/GetWechatUserByGroup', this.userPostData)
            allAxios = this.$axiox.getList(url)
          } else {
            url = this.$commonJs.returnQuery('/api/Group/GetAllGroupUsers', this.userPostData)
            allAxios = this.$axiox.getList(url)
          }
        } else {
          url = this.$commonJs.returnQuery('/api/Group/GetAllGroupUsers', this.userPostData)
          allAxios = this.$axiox.getList(url)
        }
      } else if (this.pickerModel === 'Exception') {
        this.userPostData.PageIndex = pageIndex
        url = this.$commonJs.returnQuery('/api/WorkWechatApp/' + this.appId + '/exceptionUsers/addPage', this.userPostData)
        allAxios = this.$axiox.getList(url)
      } else if (this.pickerModel === 'Dialogue') {
        this.usergroupData.PageIndex = pageIndex
        this.usergroupData.role = 'DialogueAdmin'
        url = this.$commonJs.returnQuery('/api/Group/GetAllGroupUsers', this.usergroupData)
        allAxios = this.$axiox.getList(url)
      } else if (this.pickerModel === 'allRelease') {
        this.userPostData.PageIndex = pageIndex
        this.userPostData['isTag'] = true
        url = this.$commonJs.returnQuery('/api/Group/GetAllGroupUsers', this.userPostData)
        allAxios = this.$axiox.getList(url)
      } else if (this.pickerModel === 'wechatUser') {
        this.userPostData.PageIndex = pageIndex
        url = this.$commonJs.returnQuery('/api/wechat/GetWechatUsers', this.userPostData)
        allAxios = this.$axiox.getList(url)
      } else if (this.pickerModel === 'employeeDepartment') {
        this.groupEmployeePostData.PageIndex = pageIndex
        url = this.$commonJs.returnQuery('/api/Group/GetAllGroupEmployees', this.groupEmployeePostData)
        allAxios = this.$axiox.getList(url)
      }else {
        this.userPostData.PageIndex = pageIndex
        let data = {
          keywords: this.userPostData.keywords,
          chineseName: this.userPostData.ChineseName,
          email: this.userPostData.Email,
          department: this.userPostData.Department,
          jobTitle: this.userPostData.JobTitle,
          pageIndex: pageIndex,
          pageSize: this.userPostData.PageSize
        }
        allAxios = this.$axiox.post('/api/employee/GetAllEmployees', data)
      }
      allAxios.then(msg => {
        this.userPage = pageIndex
        this.userList = msg.data || msg
        this.originUserList = JSON.parse(JSON.stringify(msg.data || msg))
        this.userTotalPage = Math.ceil(msg.total / this.userPostData.PageSize)
        this.userTotalCount = msg.total
        let num = 0
        for (let i = 0; i < this.userList.length; i++) {
          if (this.pickerModel === 'wechatUser') {
            if (this.chooseUserIdList.indexOf(this.userList[i].id) >= 0) {
              this.$set(this.userList[i], 'checked', true)
            }
          } else if (this.pickerModel === 'groups') {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.$set(this.userList[i], 'checked', true)
            }
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].employeeId) >= 0) {
              this.$set(this.userList[i], 'checked', true)
            }
          }
          if (this.userList[i].checked) {
            num++
          }
        }
        if (num === this.userList.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
        console.log(this.userTotalPage)
      })
    },
    // 选择用户
    chooseUserInfo (item) {
      if (this.pickerModel === 'wechatUser') {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.id) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.id)
            this.chooseIdList.push(item.id)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.id) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.id), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.id), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.id), 1)
          } else {
          }
        }
      } else if (this.pickerModel === 'groups') {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      }  else if (this.pickerModel === 'employeeDepartment') {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      } else {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.employeeId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.employeeId)
            this.chooseIdList.push(item.employeeId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.employeeId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.employeeId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.employeeId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.employeeId), 1)
          } else {
          }
        }
      }
    },
    removeSelect (id) {
      this.chooseUserList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      let num = 0
      for (let i = 0; i < this.userList.length; i++) {
        if (this.pickerModel === 'wechatUser') {
          if (this.userList[i].id === id) {
            this.$set(this.userList[i], 'checked', false)
          }
        } else if (this.pickerModel === 'groups') {
          if (this.userList[i].openId === id) {
            this.$set(this.userList[i], 'checked', false)
          }
        } else {
          if (this.userList[i].employeeId === id) {
            this.$set(this.userList[i], 'checked', false)
          }
        }
        if (this.userList[i].checked) {
          num++
        }
      }
      if (num === this.userList.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    cancelModel () {
      this.$emit('newShowModel', false)
    },
    confirModel () {
      this.$emit('newShowModel', false)
      let dataList = {
        chooseUserIdList: this.chooseUserIdList,
        chooseUserList: this.chooseUserList,
        chooseIdList: this.chooseIdList
      }
      this.$emit('choosedConfirm', dataList)
    }
  },
  components: {
    'newPage': newPage
  },
  watch: {
    newShowModel (value) {
      console.log(value)
      if (value) {
        this.chooseUserIdList = []
        this.chooseIdList = []
        this.chooseUserList = []
        this.userPage = 1
        this.userPostData = {
          groupId: '0',
          value: '',
          name: '',
          Email: '',
          org_Acronym: '',
          PageIndex: 1,
          PageSize: this.$commonJs.commonPageSize
        }
        this.getAllUser(this.userPage)
      }
    },
    "userPostData.FieldId" (newData) {
      console.log(newData, 'userPostData.Field')
      if (newData) {
        let fieldData = this.fildsList.filter(item => item.postId == newData)
        let ids = fieldData.map(item => item.id)
        console.log(fieldData, 'fieldData')
        this.getIndicationsList(ids)
      } else {
        this.getIndicationsList()
      }
    }
  }
}
</script>

<style scoped>
  .allSelectedMember{
    padding: 10px 20px;
    border-radius: 10px;
    background: #FEF5F0;
    margin: 10px 0;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .allSelectedMember b{
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/userPicker.vue